<template>
  <category-layout @changeLanguage="getItems">
    <categories :categories="categories"/>
    <pagination400 class="mt-3" :on-change-page="changePage" :meta="pagination"/>
  </category-layout>
</template>

<script>
import {mapGetters} from "vuex";
import categoryLayout from "../../components/dashboard/category/layout";
import Categories from "../../components/dashboard/category/categories";
import Pagination400 from "@/plugin/miw-components/pagination/Pagination-400.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "Category",
  components: {Pagination400, categoryLayout, Categories},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
      filteredCategories: "Category/getFilteredCategories",
      pagination: "Category/getPagination",
    }),
  },
  methods: {
    getItems() {
      this.changePage()
    },
    changePage(page = 1) {
      this.$store.commit("Category/setFilters", {key: "search", value: ''});
      this.$store.commit("Category/setCategories", {});
      if (findAttributeOnSiteInfo('dashboard_category_pagination')[0] == 0) {
        this.$store.dispatch("Category/getDashboardCategories");
      } else {
        this.$store.dispatch("Category/getDashboardCategoriesWithPagination", page)

      }
    }
  },
  async mounted() {
    this.$store.commit("Category/setFilteredCategories", {});
    await this.getItems()
  },
  destroyed() {
    this.$store.commit("Category/setFilters", {key: "search", value: ''});
  }
};
</script>
<style scoped>

</style>
